






















import { defineComponent, toRefs, PropType, computed, onMounted, ref } from '@vue/composition-api';
import {
  AcoFormData,
  ACTION_TYPE,
  AdgroupFormData,
  AdType,
  AppInfo,
  CampaignFormData,
  FullNormalFormData,
} from '@tt4b/ttam-enums';

import Tracking from './index';
import { useCreativeTrackingValidate } from '@tt4b/ttam-hooks';

const name = 'ttam-tracking-live-compose';

export default defineComponent({
  name,
  components: {
    TtamTrackingUrlSetting: Tracking.TtamTrackingUrlSetting,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData & AcoFormData>,
      default: () => ({} as FullNormalFormData),
    },
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    appInfo: {
      type: Object as PropType<AppInfo>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: ACTION_TYPE.CREATE,
    },
    currentAdType: {
      type: Number as PropType<AdType>,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, creativeData, appInfo, createMode, isDisabledCreative, currentAdType } =
      toRefs(props);
    const { trackUrlValidator, actionTrackUrlValidator } = useCreativeTrackingValidate({
      createMode,
      appInfo,
      adgroupData,
    });
    const { isOnlyShowImpressionUrl, trackingUrlTitle } = Tracking.usePropsImpressionUrl({
      adgroupData,
      campaignData,
      currentAdType,
    });

    const { isDisabledClickTrackUrl } = Tracking.useTrackUrl({
      adgroupData,
      campaignData,
      creativeData,
      appInfo,
      createMode,
      isDisabledCreative,
    });

    const _trackUrl = computed({
      get: () => creativeData.value?.trackUrl?.[0] ?? '',
      set: (val: string) => emit('change', { trackUrl: [val] }),
    });

    const _actionTrackUrl = computed({
      get: () => creativeData.value?.actionTrackUrl?.[0] ?? '',
      set: (val: string) => emit('change', { actionTrackUrl: [val] }),
    });

    return {
      _trackUrl,
      _actionTrackUrl,
      trackUrlValidator,
      actionTrackUrlValidator,
      isOnlyShowImpressionUrl,
      trackingUrlTitle,
      isDisabledClickTrackUrl,

      name,
    };
  },
});
